export default __webpack_public_path__ + "static/logo-a752a3ac9dbf52148931caa81bc028f4.png";